import React from 'react';
import DataGrid, { Column, Scrolling } from 'devextreme-react/data-grid';
import { HeadTitle } from '../../components/HeadTitle';
import { Header } from '../../components/Header';
import styles from './EcnHelpPage.module.scss';

const title = 'ECN REJECT TABLE';

const data = [
  {

    reason: 'display qty must be greater than round lot',
    desc: 'Show/Display quantity is less than minimum quote size',
    reject: 'Y'
  },
  {

    reason: 'symbol not ECN enabled',
    desc: 'The security does not trade on system',
    reject: 'N'
  }, {

    reason: 'system not open',
    desc: 'System is not open for trading',
    reject: 'N'
  }, {

    reason: 'CXL ON ROUTOUT',
    desc: 'When \'Do Not Route\' instruction is populated and the order becomes marketable on external venues',
    reject: 'N'
  }, {

    reason: 'Halt',
    desc: 'The security is halted for trading',
    reject: 'N'
  }, {

    reason: 'invalid symbol',
    desc: 'Not a valid security',
    reject: 'N'
  },
  {

    reason: 'price percentage exceeded',
    desc: 'The order price is away from the inside price by more than price based percentage',
    reject: 'N'
  }, {

    reason: 'too many routings',
    desc: 'Multiple route rejects from an unresponsive market participant/external venue',
    reject: 'N'
  }, {

    reason: 'order marketable to existing quote/book',
    desc: 'When \'Post Only\' instruction is populated and the order is marketable on arrival',
    reject: 'N'
  }, {

    reason: 'trade prevention cancel',
    desc: 'Unsolicited cancel to prevent self-trade',
    reject: 'N'
  }, {

    reason: 'ISO canceled',
    desc: 'Unsolicited cancel for remaining quantity of an ISO order',
    reject: 'N'
  }, {

    reason: 'exceed max share',
    desc: 'Order quantity greater than 99,999,999',
    reject: 'N'
  }, {

    reason: 'exceeds notional value',
    desc: 'Order notional value greater than $1,000,000',
    reject: 'N'
  }, {

    reason: 'peg not allowed on symbol',
    desc: 'Security is not enabled for pegging',
    reject: 'N'
  }

];

var loadingOptions = {
  enabled: false
};

class EcnHelpPage extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
    };
  }

  render () {
    return (
      <div>
        <HeadTitle title={title} />
        <Header title={title} />
        <DataGrid
          id='ecnHelpPage'
          className={styles.gridContainer}
          dataSource={data}
          allowColumnReordering
          hoverStateEnabled
          columnAutoWidth
          rowAlternationEnabled
          showBorders
          repaintChangesOnly
          loadPanel={loadingOptions}
        >
          <Scrolling mode='infinite' rowRenderingMode='virtual' preloadEnabled />
          <Column dataField='reason' caption='Reject/Unsolicited Cancel' />
          <Column dataField='desc' caption='Description' />
          <Column dataField='reject' caption='Session Level Reject' />

        </DataGrid>

      </div>
    );
  }
}
export default EcnHelpPage;
